import React, { useEffect } from 'react';
import { EditorStringModel } from '../../Types/EditorString';
import EditorString from '../EditorString/EditorString';
import { CollectionItemProps } from './Types/CollectionItem';
import CollectionItem from './CollectionItem';
import CollectionStoreInput from './CollectionStoreInput';
import { useDispatch } from 'react-redux';
import { CollectionStoreActions } from '../../Reducers/CollectionStore.reducer';
import { useTypedSelector } from '../../Hooks/useTypedSelector';

interface CollectionStore {
  title: string;
  description: EditorStringModel;
  collectionItems: CollectionItemProps[];
}

const CollectionStore = (props: CollectionStore) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      CollectionStoreActions.SetCollectionItems({
        items: props.collectionItems,
      })
    );
  }, [dispatch, props.collectionItems]);

  const { selectedCollectionItem, filteredItems } = useTypedSelector(
    (state) => state.CollectionStoreReducer
  );

  return (
    <div className="container container--narrow pt-6 lg:pt-10">
      <div className="max-w-[568px]">
        {props.title && <h1>{props.title}</h1>}
        {props.description.value && (
          <EditorString value={props.description.value} />
        )}
      </div>
      <div className="mt-8">
        <CollectionStoreInput />
        <div className="mb-10 mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {selectedCollectionItem ? (
            <CollectionItem {...selectedCollectionItem} />
          ) : (
              filteredItems.map((item) => (
                <CollectionItem key={item.name + item.fileSize} {...item} />
              ))
          )}
        </div>
      </div>
    </div>
  );
};

export default CollectionStore;
